import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import Seo from '../common/Seo';

const ForgotPassword: React.FC = () => {
  const [email, setEmail] = useState<string>('');
  const [message, setMessage] = useState<string>('');
  const [error, setError] = useState<string>('');
  const [loading, setLoading] = useState<boolean>(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setMessage('');
    setError('');

    try {
      const response = await axios.post('https://www.sportyreplay.de/api/auth/forgot-password.php', {
        email
      }, { withCredentials: true });

      setMessage(response.data.message);
      setEmail('');
    } catch (err: any) {
      setError(err.response?.data?.message || 'Ein Fehler ist aufgetreten');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gray-900 flex flex-col items-center pt-16">
      <Seo title="Passwort vergessen | SportyReplay" noindex />
      <div className="text-3xl font-bold mb-8">
        <span className="text-white">Sporty</span>
        <span className="text-orange-500">Replay</span>
      </div>
      
      <div className="w-full max-w-md bg-white rounded-lg shadow-xl p-8">
        <h2 className="text-2xl font-bold text-gray-800 mb-6">Passwort zurücksetzen</h2>
        
        <p className="mb-6 text-gray-600">
          Geben Sie Ihre E-Mail-Adresse ein, und wir senden Ihnen einen Link zum Zurücksetzen Ihres Passworts.
        </p>
        
        {message && (
          <div className="mb-4 p-2 bg-green-100 border border-green-400 text-green-700 rounded">
            {message}
          </div>
        )}
        
        {error && (
          <div className="mb-4 p-2 bg-red-100 border border-red-400 text-red-700 rounded">
            {error}
          </div>
        )}
        
        <form onSubmit={handleSubmit}>
          <div className="mb-4">
            <label className="block text-gray-700 mb-2" htmlFor="email">
              E-Mail
            </label>
            <input
              type="email"
              id="email"
              className="w-full p-3 border border-gray-300 rounded focus:ring-2 focus:ring-blue-500 focus:border-transparent"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>
          
          <button
            type="submit"
            className="w-full bg-orange-500 text-white py-3 px-4 rounded hover:bg-orange-600 transition duration-200"
            disabled={loading}
          >
            {loading ? 'Wird gesendet...' : 'Link senden'}
          </button>
        </form>
        
        <p className="mt-4 text-center text-gray-600">
          <Link to="/login" className="text-orange-500 hover:text-orange-700">
            Zurück zum Login
          </Link>
        </p>
      </div>
    </div>
  );
};

export default ForgotPassword;